var _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimelineClockIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 12",
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "url(#pattern0_16798_31414)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_16798_31414",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_16798_31414",
    transform: "scale(0.015625)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_16798_31414",
    "data-name": "pending (1).png",
    width: 64,
    height: 64,
    preserveAspectRatio: "none",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAA7DAAAOwwHHb6hkAAAAGXRFWHRTb2Z0d2FyZQB3d3cuaW5rc2NhcGUub3Jnm+48GgAABQlJREFUeJztml9oHEUcx7+/2dg+5JBgRGibtiINlVRKye7enUmUnmKtKKglJg/Gh6JvQkREqEURxIqCSqG+FEQQK9Jo0Ae1ah7Ol5Tr3t5ZYyPYoKlWCyLFgNuI5HZ+PuSPIXb39mZnNw25z1Pufr/5zXe+md2b3RmgSZMmTZqsXyiNTlzX3cbMvQBuB9BFRDcyczuAdgAGgCsALgP4mZnPE9FZKeXXuVzufNLaEjOgUqnskFIeBDAEYJtimYvMPCKEeNeyrO80yltCuwGu697PzM8A2Ku5/jiAI7Ztn9JYU5/Acrl8G4A3Adyjq+bVYOaSEOJJy7KqOurFNmBycnLD7OzsqwCGMX89p4EP4FhbW9uhzs7Of+IUimVAqVTqMAxjBPM3t9WgSkQDlmX9qFpA2QDHce4E8CER3aRaQxOXhRAPmKZZUmmsZIDrun3M/AWAVpX2CXAFwMO2bY812lA02sBxHJuZP0P8wY8y8yZm3gRgNGatVgAfu66ba7RhQzNg4bf9DIAbGu1oJYZhbOnu7r4EANVqdbPv+7/FrYn5xVTWtu2fojaIPAOKxWKL7/vvQcPgAWBx8Cv/jkk7gJGpqamNURtENqC1tfVFIsoryUoXc2Zm5pWoyZEMcF03R0TPqWtKnaccx9kTJTGSAcx8BOktcnRgENFbURLrGlAul3sB3B1bUvr0uq67r15SXQOY+SU9etJHSvl8vZxQAxzH2UVEd+mTlC5EdMfCQ1ogoQYQ0SN6Ja0Kj4UF610C/RqFrBaDYcFAA1zXvRXALu1y0md7pVLZERQMNICZs8noSR/f9wtBsbBLIPTmsZYgot1BsXVhAICdQYEwAwIbrUFuCQqEGXCtvOzQwfVBgTADNiQgJIyTCdZWMuC6BIQsUSqVOpZ/9jxvCMmZEDjOMAP8BIQsYRjGsWKx2LL4uVAo1BI0YTYoEGbAxQSELOehTCbzwUoTpqenHwVwQnNffwQFwhZCFzSLuBr9mUzmxHITBgYGfM/zDkLvTAj8ZwYaQEQXNAoIYzCFmXA2KBB2CXyjqfMoJDoTmDlw0yTsEmh4kyEmgytNWHZj/CROYSnl6aBY6L6A67qTzNwVp3MFTnqeN1QoFGqLXziOs5WIflGsN23bttJKEAvbX2nzv5kghFDew2Tm98PiLWFBIcTbUsqnkdJRmmUMZjKZjY7jDAshiJmPK9aRzPxOWELdgZXL5c8B3KcoYLUZs2079M1w3bfCRHRUn550EUK8UTenXoJpmmOYP5+z1jhlmuaX9ZKizAAG8DiAWEdRUqbGzM9GSYy0NWbb9g8AXo8lKUWI6Gg2m52Mkht5d9jzvJcBTCirSo9xAIejJjf087ZwkOEMgI66yavD73Nzc2ZPT0/kwxYNHZHp7u6+REQPAvAalpY8HjMfaGTwgMIZIcuyqkKIflxbJsxIKfdls9nANX8Qyiu8SqWyW0r5KYCtqjU08SeA/bZtOyqNG54Bi5imOeH7fg8RfataQwOnpZSm6uCBGAYAQD6f/xWATUSHkO46oQbgNSLam8vlpuMU0vaQUyqVugzDOA6gT1fNAL4SQhw2TbOio1gSx+X7mHkYwAHoPVc0TkQvWJZV1Fgzucfccrm8k4ieYOb9UN9nnGDmUSnlR/l8/nud+hZJ5Tm/Wq1urtVq9wLYQ0Q3E9F2Zt6C/2bI3wD+YuYpAOcAnJNSOvl8fioNfU2aNGnSZL3yL68CtuUtnjTBAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineClockIcon);
export default __webpack_public_path__ + "static/media/timeline-clock-icon.58f1d56ab83f7af4a74e7a53132886ef.svg";
export { ForwardRef as ReactComponent };